import {
    Card,
    CardContent,
    Grid,
    Typography
} from "@common-ui/ui";

export const NoClient = (props) => {
    return (
        <Grid
            container
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ minHeight: '50vh' }}
        >
            <Card variant="outlined" style={{ padding: "2rem", height: "20vh", minWidth: "25vw" }}>
                <CardContent>
                    <Typography color="primary" sx={{ fontSize: 14 }} gutterBottom>
                        No active clients could be found for this account
                    </Typography>
                    <Typography color="primary" variant="h3" component="div">
                        Let's get you started with the latest version
                    </Typography>
                </CardContent>
            </Card>
        </Grid >
    );
}